<div class="flex flex-col-reverse items-center fixed z-50 bottom-0 left-0 right-0 p-2 pointer-events-none">
  <div *ngFor="let item of notifications; index as index;" class="w-full max-w-xl m-2 pointer-events-auto">
    <app-notification [type]="item.type" [icon]="item.icon" [message]="item.message" [canClose]="item.canClose" [duration]="item.duration" (close)="closeNotification(index)"></app-notification>
  </div>
</div>
